import { Tag } from 'foundations-components/transitional/components/Tag';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MobileTagButton({
  children,
  onClick,
  closeable
}) {
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Tag, {
      use: closeable ? 'calypso' : undefined,
      closeable: closeable,
      paddingBlock: "50",
      children: children
    })
  });
}